import {LandingB2C} from '../controllers/landing-b2c';
import init from "../utils/init";
init.addModulo(LandingB2C)
